import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

interface StorageImageOptions {
  height?: number;
  quality?: number;
  resize?: "cover" | "contain";
  width?: number;
}

export function getOptimizedStorageImageUrl(
  url: string,
  options: StorageImageOptions = {},
) {
  if (!url.includes("/storage/v1/object/public/")) {
    return url;
  }

  const [baseUrl, existingQuery = ""] = url.split("?");
  const transformedUrl = baseUrl.replace(
    "/storage/v1/object/public/",
    "/storage/v1/render/image/public/",
  );

  const params = new URLSearchParams(existingQuery);

  if (options.width) params.set("width", String(options.width));
  if (options.height) params.set("height", String(options.height));
  if (options.resize) params.set("resize", options.resize);
  if (options.quality) params.set("quality", String(options.quality));

  const queryString = params.toString();
  return queryString ? `${transformedUrl}?${queryString}` : transformedUrl;
}
